
export const messages = {
  en: {
    carDetail: {
      vehicleInfo: 'Vehicle Information',
      licensePlate: 'License Plate:',
      carType: 'Car Type:',
      licenseType: 'License Type:',
      leaseStart: 'Lease Start:',
      leaseEnd: 'Lease End:',
      remark: 'Remark:',
      parkingLot: 'Parking Lot:',
      status: 'Status:',
      relatedHouse: 'Related House:',
      contact: 'Contact Person:',
      tel: 'Contact Phone:',
      vehicleFee: 'Vehicle Month Card',
      paymentRecord: 'Month Card Payment Record',
      modificationRecord: 'Modification Record',
      memberVehicle: 'Member Vehicle',
      ownerInfo: 'Owner Info',
      ownerHouse: 'Owner House',
      ownerVehicle: 'Owner Vehicle',
      ownerArrears: 'Owner Arrears',
      licenseSync: 'License Sync',
      parkingApplication: 'Parking Application',
      accessRecord: 'Access Record',
      coupon: 'Coupon',
      couponVerification: 'Coupon Verification'
    },
    carDetailFee: {
      createFee: 'Buy Month Card',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      amountReceivable: 'Amount Receivable',
      accountingTime: 'Accounting Time',
      receivablePeriod: 'Receivable Period',
      remark: 'Remark',
      status: 'Status',
      operation: 'Operation',
      previousReading: 'Previous Reading',
      currentReading: 'Current Reading',
      unitPrice: 'Unit Price',
      additionalFee: 'Additional Fee',
      fixedFee: 'Fixed Fee',
      payment: 'Payment',
      history: 'History',
      cancel: 'Cancel',
      change: 'Change',
      detail: 'Detail',
      paymentNotice: 'Please go to the business acceptance page for payment'
    },
    carDetailHisFee: {
      feeItem: 'Fee Item',
      chargeObject: 'Charge Object',
      cycle: 'Cycle (months)',
      receivableAmount: 'Receivable/Received (yuan)',
      paymentMethod: 'Payment Method',
      paymentPeriod: 'Payment Period',
      paymentTime: 'Payment Time',
      cashier: 'Cashier',
      status: 'Status',
      remark: 'Remark',
      operation: 'Operation',
      detail: 'Detail',
      accountDeduction: 'Account Deduction'
    },
    carDetailTransactionCar: {
      syncId: 'Sync ID',
      deviceCode: 'Device Code',
      objectType: 'Object Type',
      objectName: 'Object Name',
      command: 'Command',
      status: 'Status',
      remark: 'Remark',
      syncTime: 'Sync Time',
      operation: 'Operation',
      resync: 'Resync'
    },
    carDetailApplyParkingSpace: {
      applyParkingSpace: 'Apply Parking Space',
      applyId: 'Apply ID',
      carNum: 'Car Number',
      parkingSpace: 'Parking Space',
      none: 'None',
      carBrand: 'Car Brand',
      carType: 'Car Type',
      color: 'Color',
      startTime: 'Start Time',
      endTime: 'End Time',
      applicant: 'Applicant',
      phone: 'Phone',
      auditResult: 'Audit Result',
      operation: 'Operation',
      audit: 'Audit',
      edit: 'Edit',
      delete: 'Delete',
      pendingReview: 'Pending Review',
      pendingPayment: 'Pending Payment',
      completed: 'Completed',
      auditFailed: 'Audit Failed',
      abnormalStatus: 'Abnormal Status',
      familyCar: 'Family Car',
      bus: 'Bus',
      truck: 'Truck',
      abnormalVehicle: 'Abnormal Vehicle'
    },
    carDetailCarInout: {
      entryImage: 'Entry Image',
      inoutId: 'Inout ID',
      carStatus: 'Car Status',
      entry: 'Entry',
      exit: 'Exit',
      carNum: 'Car Number',
      parkingLot: 'Parking Lot',
      billingRule: 'Billing Rule',
      carType: 'Car Type',
      entryTime: 'Entry Time',
      exitTime: 'Exit Time',
      parkingTime: 'Parking Time',
      hour: 'hour',
      minute: 'minute',
      chargeAmount: 'Charge Amount',
      remark: 'Remark'
    },
    carDetailCoupon: {
      car: 'Car',
      coupon: 'Coupon',
      shop: 'Shop',
      parkingLot: 'Parking Lot',
      giveWay: 'Give Way',
      couponType: 'Coupon Type',
      value: 'Value',
      startTime: 'Start Time',
      endTime: 'End Time',
      giveTime: 'Give Time',
      status: 'Status',
      remark: 'Remark'
    },
    carDetailCouponOrder: {
      orderId: 'Order ID',
      carNum: 'Car Number',
      coupon: 'Coupon',
      shop: 'Shop',
      parkingLot: 'Parking Lot',
      machine: 'Machine',
      verifyTime: 'Verify Time',
      remark: 'Remark'
    },
    ownerDetailOweFee: {
      paymentObject: 'Payment Object',
      ownerName: 'Owner Name',
      phone: 'Owner Phone',
      startTime: 'Start Time',
      endTime: 'End Time',
      totalAmount: 'Total Amount',
      updateTime: 'Update Time',
      paymentNotice: 'Payment Notice',
      batchPayment: 'Batch Payment'
    }
  },
  zh: {
    carDetail: {
      vehicleInfo: '车辆信息',
      licensePlate: '车牌号：',
      carType: '车类型：',
      licenseType: '车牌类型：',
      leaseStart: '起租时间：',
      leaseEnd: '结租时间：',
      remark: '备注：',
      parkingLot: '停车场：',
      status: '状态：',
      relatedHouse: '关联房屋：',
      contact: '联系人：',
      tel: '联系电话：',
      vehicleFee: '车辆月卡',
      paymentRecord: '月卡缴费记录',
      modificationRecord: '修改记录',
      memberVehicle: '成员车辆',
      ownerInfo: '业主信息',
      ownerHouse: '业主房屋',
      ownerVehicle: '业主车辆',
      ownerArrears: '业主欠费',
      licenseSync: '车牌同步',
      parkingApplication: '车位申请',
      accessRecord: '出入场记录',
      coupon: '优惠券',
      couponVerification: '优惠券核销'
    },
    carDetailFee: {
      createFee: '购买月卡',
      feeItem: '费用项目',
      feeFlag: '费用标识',
      feeType: '费用类型',
      amountReceivable: '应收金额',
      accountingTime: '建账时间',
      receivablePeriod: '应收时间段',
      remark: '说明',
      status: '状态',
      operation: '操作',
      previousReading: '上期度数',
      currentReading: '本期度数',
      unitPrice: '单价',
      additionalFee: '附加费',
      fixedFee: '固定费',
      payment: '缴费',
      history: '历史',
      cancel: '取消',
      change: '变更',
      detail: '详情',
      paymentNotice: '缴费请到业务受理页面缴费'
    },
    carDetailHisFee: {
      feeItem: '费用项目',
      chargeObject: '收费对象',
      cycle: '周期(月)',
      receivableAmount: '应收/实收(元)',
      paymentMethod: '支付方式',
      paymentPeriod: '缴费周期',
      paymentTime: '缴费时间',
      cashier: '收费员',
      status: '状态',
      remark: '备注',
      operation: '操作',
      detail: '详情',
      accountDeduction: '账户扣减'
    },
    carDetailTransactionCar: {
      syncId: '同步ID',
      deviceCode: '设备编码',
      objectType: '对象类型',
      objectName: '对象名称',
      command: '指令',
      status: '状态',
      remark: '说明',
      syncTime: '同步时间',
      operation: '操作',
      resync: '重新同步'
    },
    carDetailApplyParkingSpace: {
      applyParkingSpace: '申请车位',
      applyId: '申请ID',
      carNum: '车牌号',
      parkingSpace: '停车位',
      none: '无',
      carBrand: '汽车品牌',
      carType: '车辆类型',
      color: '颜色',
      startTime: '起租时间',
      endTime: '结租时间',
      applicant: '申请人',
      phone: '手机号',
      auditResult: '审核结果',
      operation: '操作',
      audit: '审核',
      edit: '修改',
      delete: '删除',
      pendingReview: '待审核',
      pendingPayment: '待缴费',
      completed: '完成',
      auditFailed: '审核失败',
      abnormalStatus: '状态异常',
      familyCar: '家用小汽车',
      bus: '客车',
      truck: '货车',
      abnormalVehicle: '异常车辆'
    },
    carDetailCarInout: {
      entryImage: '进场图',
      inoutId: '进出场编号',
      carStatus: '车辆状态',
      entry: '进场',
      exit: '出场',
      carNum: '车牌号',
      parkingLot: '停车场',
      billingRule: '计费规则',
      carType: '车牌类型',
      entryTime: '进场时间',
      exitTime: '出场时间',
      parkingTime: '停车时间',
      hour: '小时',
      minute: '分',
      chargeAmount: '收费金额',
      remark: '说明'
    },
    carDetailCoupon: {
      car: '车辆',
      coupon: '优惠券',
      shop: '商家店铺',
      parkingLot: '停车场',
      giveWay: '赠送方式',
      couponType: '优惠方式',
      value: '面值',
      startTime: '开始时间',
      endTime: '结束时间',
      giveTime: '赠送时间',
      status: '状态',
      remark: '说明'
    },
    carDetailCouponOrder: {
      orderId: '核销订单',
      carNum: '核销车辆',
      coupon: '优惠券',
      shop: '商家店铺',
      parkingLot: '停车场',
      machine: '道闸',
      verifyTime: '核销时间',
      remark: '说明'
    },
    ownerDetailOweFee: {
      paymentObject: '缴费对象',
      ownerName: '业主姓名',
      phone: '业主手机',
      startTime: '开始时间',
      endTime: '结束时间',
      totalAmount: '总金额',
      updateTime: '更新时间',
      paymentNotice: '缴费通知',
batchPayment: '批量缴费'
    }
  },
  'zh-TW': {
    carDetail: {
      vehicleInfo: '車輛信息',
      licensePlate: '車牌號：',
      carType: '車類型：',
      licenseType: '車牌類型：',
      leaseStart: '起租時間：',
      leaseEnd: '結租時間：',
      remark: '備註：',
      parkingLot: '停車場：',
      status: '狀態：',
      relatedHouse: '關聯房屋：',
      contact: '聯絡人：',
      tel: '聯絡電話：',
      vehicleFee: '車輛月卡',
      paymentRecord: '月卡繳費記錄',
      modificationRecord: '修改記錄',
      memberVehicle: '成員車輛',
      ownerInfo: '業主信息',
      ownerHouse: '業主房屋',
      ownerVehicle: '業主車輛',
      ownerArrears: '業主欠費',
      licenseSync: '車牌同步',
      parkingApplication: '車位申請',
      accessRecord: '出入場記錄',
      coupon: '優惠券',
      couponVerification: '優惠券核銷'
    },
    carDetailFee: {
      createFee: '購買月卡',
      feeItem: '費用項目',
      feeFlag: '費用標識',
      feeType: '費用類型',
      amountReceivable: '應收金額',
      accountingTime: '建賬時間',
      receivablePeriod: '應收時間段',
      remark: '說明',
      status: '狀態',
      operation: '操作',
      previousReading: '上期度數',
      currentReading: '本期度數',
      unitPrice: '單價',
      additionalFee: '附加費',
      fixedFee: '固定費',
      payment: '繳費',
      history: '歷史',
      cancel: '取消',
      change: '變更',
      detail: '詳情',
      paymentNotice: '繳費請到業務受理頁面繳費'
    },
    carDetailHisFee: {
      feeItem: '費用項目',
      chargeObject: '收費對象',
      cycle: '週期(月)',
      receivableAmount: '應收/實收(元)',
      paymentMethod: '支付方式',
      paymentPeriod: '繳費週期',
      paymentTime: '繳費時間',
      cashier: '收費員',
      status: '狀態',
      remark: '備註',
      operation: '操作',
      detail: '詳情',
      accountDeduction: '賬戶扣減'
    },
    carDetailTransactionCar: {
      syncId: '同步ID',
      deviceCode: '設備編碼',
      objectType: '對象類型',
      objectName: '對象名稱',
      command: '指令',
      status: '狀態',
      remark: '說明',
      syncTime: '同步時間',
      operation: '操作',
      resync: '重新同步'
    },
    carDetailApplyParkingSpace: {
      applyParkingSpace: '申請車位',
      applyId: '申請ID',
      carNum: '車牌號',
      parkingSpace: '停車位',
      none: '無',
      carBrand: '汽車品牌',
      carType: '車輛類型',
      color: '顏色',
      startTime: '起租時間',
      endTime: '結租時間',
      applicant: '申請人',
      phone: '手機號',
      auditResult: '審核結果',
      operation: '操作',
      audit: '審核',
      edit: '修改',
      delete: '刪除',
      pendingReview: '待審核',
      pendingPayment: '待繳費',
      completed: '完成',
      auditFailed: '審核失敗',
      abnormalStatus: '狀態異常',
      familyCar: '家用小汽車',
      bus: '客車',
      truck: '貨車',
      abnormalVehicle: '異常車輛'
    },
    carDetailCarInout: {
      entryImage: '進場圖',
      inoutId: '進出廠編號',
      carStatus: '車輛狀態',
      entry: '進場',
      exit: '出廠',
      carNum: '車牌號',
      parkingLot: '停車場',
      billingRule: '計費規則',
      carType: '車牌類型',
      entryTime: '進場時間',
      exitTime: '出廠時間',
      parkingTime: '停車時間',
      hour: '小時',
      minute: '分',
      chargeAmount: '收費金額',
      remark: '說明'
    },
    carDetailCoupon: {
      car: '車輛',
      coupon: '優惠券',
      shop: '商家舖鋪',
      parkingLot: '停車場',
      giveWay: '贈送方式',
      couponType: '優惠方式',
      value: '面值',
      startTime: '開始時間',
      endTime: '結束時間',
      giveTime: '贈送時間',
      status: '狀態',
      remark: '說明'
    },
    carDetailCouponOrder: {
      orderId: '核銷訂單',
      carNum: '核銷車輛',
      coupon: '優惠券',
      shop: '商家舖鋪',
      parkingLot: '停車場',
      machine: '道閘',
      verifyTime: '核銷時間',
      remark: '說明'
    },
    ownerDetailOweFee: {
      paymentObject: '繳費對象',
      ownerName: '業主姓名',
      phone: '業主手機',
      startTime: '開始時間',
      endTime: '結束時間',
      totalAmount: '總金額',
      updateTime: '更新時間',
      paymentNotice: '繳費通知',
      batchPayment: '批量繳費'
    }
  }
}
